import {
  allRoles,
  cohortDirectoryRoles,
  operationsRoles,
  writeOperationsRoles,
  type AppRouteDefinition
} from "./route-types";

export const coreRoutes: AppRouteDefinition[] = [
  {
    id: "login",
    path: "/login",
    label: "Login",
    capability: "auth:view",
    roles: allRoles,
    directUrlPolicy: "allow",
    nav: false,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "dashboard",
    path: "/dashboard",
    label: "Dashboard",
    capability: "dashboard:view",
    roles: allRoles,
    directUrlPolicy: "allow",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "organizations",
    path: "/organizations",
    label: "Organisations",
    capability: "users:view",
    roles: allRoles,
    directUrlPolicy: "generic-not-found",
    platformAdminOnly: true,
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "companies",
    path: "/companies",
    label: "Companies",
    capability: "companies:view",
    roles: operationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "company-detail",
    path: "/companies/:company_id",
    label: "Company Detail",
    capability: "companies:view",
    roles: operationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: false,
    readiness: "planned-screen",
    scopeKind: "company",
    scopeParam: "company_id"
  },
  {
    id: "programs",
    path: "/programs",
    label: "Programs",
    capability: "programs:view",
    roles: operationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "program-detail",
    path: "/programs/:program_id",
    label: "Program Detail",
    capability: "programs:view",
    roles: operationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: false,
    readiness: "planned-screen",
    scopeKind: "program",
    scopeParam: "program_id"
  },
  {
    id: "cohorts",
    path: "/cohorts",
    label: "Cohorts",
    capability: "cohorts:view",
    roles: cohortDirectoryRoles,
    directUrlPolicy: "generic-not-found",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "my-cohorts",
    path: "/my-cohorts",
    label: "My Cohorts",
    capability: "cohorts:view",
    roles: ["coach", "participant"],
    directUrlPolicy: "generic-not-found",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "cohort-create",
    path: "/cohorts/new",
    label: "Create Cohort",
    capability: "cohorts:create",
    roles: writeOperationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: false,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "cohort-workspace",
    path: "/cohorts/:cohort_id",
    label: "Cohort Workspace",
    capability: "cohorts:view",
    roles: allRoles,
    directUrlPolicy: "generic-not-found",
    nav: false,
    readiness: "planned-screen",
    scopeKind: "cohort",
    scopeParam: "cohort_id"
  },
  {
    id: "participants",
    path: "/participants",
    label: "Participants",
    capability: "participants:view",
    roles: operationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    id: "participant-detail",
    path: "/participants/:participant_id",
    label: "Participant Detail",
    capability: "participants:view",
    roles: operationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: false,
    readiness: "planned-screen",
    scopeKind: "participant",
    scopeParam: "participant_id"
  },
  {
    id: "cohort-bulk-participants",
    path: "/cohorts/:cohort_id/participants/bulk",
    label: "Bulk Add Participants",
    capability: "participants:view",
    roles: writeOperationsRoles,
    directUrlPolicy: "generic-not-found",
    nav: false,
    readiness: "planned-screen",
    scopeKind: "cohort",
    scopeParam: "cohort_id"
  },
  {
    // Phase 4 org-admin home (org-admin spec §2.2). Org-scoped via the resolved
    // company scope (scopeKind:none, no URL param). Renders the ungated
    // zero-filled /analytics/* rollups (never 503), so it is nav-visible
    // (planned-screen) rather than blocked-backend.
    id: "org-admin-home",
    path: "/org",
    label: "Org Overview",
    capability: "analytics:view",
    roles: ["super_admin", "admin", "company_admin"],
    directUrlPolicy: "generic-not-found",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  },
  {
    // Phase 4 org report library (org-admin spec §2.2). D-3-scoped: shows only
    // team_admin / company_readable rows; cohort_lead sees assigned cohorts
    // download-only. The backend G3 read-path predicate is the source of truth;
    // the FE list mapper applies the same filter belt-and-suspenders.
    id: "org-reports",
    path: "/org/reports",
    label: "Org Reports",
    capability: "reports:view",
    roles: ["super_admin", "admin", "company_admin", "cohort_lead"],
    directUrlPolicy: "generic-not-found",
    nav: true,
    readiness: "planned-screen",
    scopeKind: "none"
  }
];
